'use client';
import React, { useState, useEffect } from 'react';
import Navbar from '@/app/components/pageComponets/Navbar';
import Footer from '@/app/components/pageComponets/Footer';
import { Spinner, Center } from '@chakra-ui/react';
// export const metadata = {
//   title: 'Mirrorworld Home of Bespoke Mirrors',
//   description: 'Made to Measure Mirrors',
// };

export default function Layout({ children }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    //   // Simulate loading delay
    setIsLoaded(true);
  }, []);

  return (
    <div className="sitecontainer">
      <Navbar />
      {isLoaded ? (
        <div className="content">{children}</div>
      ) : (
        <Center flex="1">
          <Spinner
            color="#0cc6de"
            thickness="15px"
            speed="0.65s"
            emptyColor="gray.200"
            size="x3"
            width="180px"
            height="180px"
          />
        </Center>
      )}
      <div className="footer">
        <Footer />
      </div>
    </div>
  );
}
